import { render } from "./AlimtalkTemplates.vue?vue&type=template&id=19b8964a&scoped=true&ts=true"
import script from "./AlimtalkTemplates.vue?vue&type=script&lang=ts"
export * from "./AlimtalkTemplates.vue?vue&type=script&lang=ts"

import "./AlimtalkTemplates.vue?vue&type=style&index=0&id=19b8964a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b8964a"]])

export default __exports__